import { LaneOutcome } from 'types/agents/QuickQuoteAgent';
import { cn } from 'utils/shadcn';

import { getOutcomeDisplay } from './reasoningHelpers';

type OutcomeChipProps = {
  outcome: LaneOutcome;
  className?: string;
};

export function OutcomeChip({ outcome, className }: OutcomeChipProps) {
  const { label, className: toneClassName } = getOutcomeDisplay(outcome);

  return (
    <span
      data-testid='agent-outcome-chip'
      className={cn(
        'inline-flex shrink-0 items-center whitespace-nowrap rounded-full border px-2 py-px text-[10.5px] font-semibold leading-4',
        toneClassName,
        className
      )}
    >
      {label}
    </span>
  );
}
